"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = (function () {
    function Constants() {
    }
    Constants.VERSION = "0.10.1";
    Constants.TOUCH_CONTEXT = "TOUCH";
    Constants.EGO_CONTEXT = "EGO";
    Constants.AR_CONTEXT = "AR";
    Constants.DEVICE_RATIO_LIMIT = 1.25;
    Constants.DEVICE_RATIO_LIMIT_LOW = 0.75;
    Constants.BASE_SCALE = 2.5;
    Constants.AR_SCALE = 1.25;
    Constants.CAMERA_FOV = 50;
    Constants.CAMERA_MIN_Z = 0.1;
    Constants.CAMERA_MAX_Z = 150;
    Constants.CAMERA_MAX_RADIUS = 5.0;
    Constants.CAMERA_MIN_RADIUS = 0.2;
    Constants.CAMERA_PINCH_PRECISION = 175;
    Constants.CAMERA_WHEEL_PRECISION_DELTA = 0.004;
    Constants.CAMERA_PINCH_PAN_DISTANCE = 150;
    Constants.CAMERA_MAX_BETA = 88.5;
    Constants.CAMERA_ANGULAR_SENSIBILITY = 2000;
    Constants.CAMERA_PAN_SENSIBILITY = 800;
    Constants.SHADOW_DARKNESS = 0.4;
    Constants.SHADOW_MIN_Z = 0.01;
    Constants.SHADOW_MAX_Z = 10;
    Constants.SHADOW_BIAS = 0.001;
    Constants.TRIGGER_MESH_SCALE = 0.15;
    Constants.TRIGGER_BUTTON_SCALE_VIEWER_FACTOR = 0.74;
    Constants.TRIGGER_BUTTON_SCALE_FACTOR = 5;
    Constants.TRIGGER_ACTION_ANIMATION_DURATION = 100;
    Constants.TRIGGER_ACTION_SCALE_FACTOR = 1.1;
    Constants.GROUND_SCALE = 0.8;
    Constants.GROUND_Z_OFFSET = 25.0;
    Constants.GROUND_DARKEN_FACTOR = 0.25;
    Constants.EGO_EYE_LEVEL = 1.62;
    Constants.EGO_CAMERA_MIN_Z = 0.015;
    Constants.EGO_CAMERA_MAX_Z = 150;
    Constants.EGO_CAMERA_FOV = 67.5;
    Constants.EGO_CAMERA_ANGULAR_SENSIBILITY = 4000;
    Constants.EGO_TRIGGER_SCALE = 0.05;
    Constants.AR_DOUBLE_TAP_RESET_THRESHOLD = 750;
    Constants.AR_PLACEMENT_MARKER_SIZE = 0.25;
    Constants.AR_DROP_SHADOW_SIZE = 1;
    Constants.AR_DROP_SHADOW_OPACITY = 0.5;
    Constants.AR_SHADOW_PLANE_SIZE = 15;
    Constants.AR_SHADOW_PLANE_OPACITY = 0.25;
    return Constants;
}());
exports.default = Constants;
